export default {"src":"/_next/static/media/bcq-small.e393ef2f.svg","height":62,"width":116};